import { render, staticRenderFns } from "./group-details.vue?vue&type=template&id=e6e468fc&scoped=true&"
import script from "./group-details.vue?vue&type=script&lang=js&"
export * from "./group-details.vue?vue&type=script&lang=js&"
import style0 from "./group-details.vue?vue&type=style&index=0&id=e6e468fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6e468fc",
  null
  
)

export default component.exports